// extracted by mini-css-extract-plugin
export default {"TyreChange":"TyreChange_TyreChange__sUjgy","vehicleList":"TyreChange_vehicleList__nzh6j","card":"TyreChange_card__hVJPU","Trucks":"TyreChange_Trucks__mjaBg"};